/* Offer pill: copy the code, unfold the capture, dismiss for the session.

   Dismissal is sessionStorage, not localStorage — an offer the customer waved
   away should stay away for this visit, not for ever. They may well want it
   next week, and a permanently hidden offer is a discount nobody can find. */
(function () {
  "use strict";

  function init(pill) {
    if (pill.__calmyOffer) return;
    pill.__calmyOffer = true;

    var key = "calmy:dismissed:" + (pill.getAttribute("data-key") || "offer");

    try {
      if (sessionStorage.getItem(key) === "1") { pill.remove(); return; }
    } catch (e) { /* private mode: show the offer rather than fail closed */ }

    var copy = pill.querySelector("[data-calmy-copy]");
    if (copy) {
      copy.addEventListener("click", function () {
        var code = copy.getAttribute("data-calmy-copy") || "";
        var done = function () {
          copy.classList.add("is-copied");
          setTimeout(function () { copy.classList.remove("is-copied"); }, 1400);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          /* Clipboard blocked or unavailable. The code is still on screen and
             still selectable, so a refusal costs the customer nothing. */
          var r = document.createRange();
          r.selectNodeContents(copy.querySelector(".cpill__codet") || copy);
          var s = window.getSelection();
          s.removeAllRanges(); s.addRange(r);
          done();
        }
      });
    }

    var more = pill.querySelector("[data-calmy-offer-expand]");
    var fold = pill.querySelector("[data-calmy-offer-fold]");
    if (more && fold) {
      more.addEventListener("click", function () {
        var open = fold.hidden;
        fold.hidden = !open;
        pill.classList.toggle("is-open", open);
        more.setAttribute("aria-expanded", open ? "true" : "false");
        if (open) {
          var input = fold.querySelector("input");
          if (input) input.focus();
        }
      });
    }

    var x = pill.querySelector("[data-calmy-offer-dismiss]");
    if (x) {
      x.addEventListener("click", function () {
        try { sessionStorage.setItem(key, "1"); } catch (e) {}
        pill.remove();
      });
    }
  }

  function boot() { document.querySelectorAll("[data-calmy-offer-pill]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
